import { call, put, select } from "redux-saga/effects";
import { Creators as CattleProducerActions } from "../ducks/cattleProducer";
import {
  getAllCattleProducers,
  getCattleProducerShow,
  saveCattleProducer,
  deleteCattleProducer,
  getCattleProducersDropdown,
} from "../../services/cattleProducerService";
import { notification } from "antd";

export function* indexCattleProducer(action) {
  try {
    const response = yield call(getAllCattleProducers, action.payload);
    const allCattleProducers = response?.data?.results || response?.data || {};
    yield put(
      CattleProducerActions.indexCattleProducersSuccess(allCattleProducers)
    );
  } catch (error) {
    yield put(CattleProducerActions.indexCattleProducersError(error));
  }
}

export function* getCattleProducer(action) {
  try {
    const response = yield call(getCattleProducerShow, action.payload);
    const cattleProducer = response?.data?.results || response?.data || {};
    yield put(CattleProducerActions.showCattleProducerSuccess(cattleProducer));
  } catch (error) {
    yield put(CattleProducerActions.showCattleProducerError(error));
  }
}

export function* storeOrUpdateCattleProducer(action) {
  try {
    const response = yield call(saveCattleProducer, action.payload);
    const newCattleProducer = response?.data?.results || response?.data || {};
    const newPayload = {
      ...action.payload,
    };
    const { translation } = yield select((state) => state.app);
    if (action.payload.id == null)
      notification.success({
        message: translation.cattleProducer.notifications.createSuccess,
      });
    else
      notification.success({
        message: translation.cattleProducer.notifications.updateSuccess,
      });

    yield put(CattleProducerActions.saveCattleProducerSuccess(newCattleProducer));
    yield put(
      CattleProducerActions.indexCattleProducers(
        newPayload.groupId,
        newPayload.farmId
      )
    );
    yield put(
      CattleProducerActions.getDropdownCattleProducers(
        newPayload.groupId,
        newPayload.farmId
      )
    );
  } catch (error) {
    const { translation } = yield select((state) => state.app);
    if (action.payload.id == null)
      notification.error({
        message: translation.cattleProducer.notifications.createError,
      });
    else
      notification.error({
        message: translation.cattleProducer.notifications.updateError,
      });

    yield put(CattleProducerActions.saveCattleProducerError(error));
  }
}

export function* deleteCattleProducerSaga(action) {
  try {
    yield call(deleteCattleProducer, action.payload);
    yield put(CattleProducerActions.deleteCattleProducerSuccess());
    const { translation } = yield select((state) => state.app);
    notification.success({
      message: translation.cattleProducer.notifications.deleteSuccess,
    });
    yield put(
      CattleProducerActions.indexCattleProducers(
        action.payload.groupId,
        action.payload.farmId
      )
    );
  } catch (error) {
    const { translation } = yield select((state) => state.app);
    if (Object.keys(error).includes("response")) {
      const { response } = error;
      if (Object.keys(response).includes("data")) {
        const {
          data: { code: errorCode },
        } = response;
        if (errorCode === 5043) {
          notification.error({
            message:
              translation.cattleProducer.notifications.error5043Message,
          });
        } else {
          notification.error({
            message: translation.cattleProducer.notifications.deleteError,
          });
        }
      }
    } else {
      notification.error({
        message: translation.cattleProducer.notifications.deleteError,
      });
    }
    yield put(CattleProducerActions.deleteCattleProducerError(error));
  }
}

export function* listDropDownCattleProducer(action) {
  try {
    let onlyActives = [];
    const response = yield call(getCattleProducersDropdown, action.payload);
    const allCattleProducers = response?.data?.results || response?.data || [];
    onlyActives = allCattleProducers.filter(
      (cattleProducer) =>
        cattleProducer.status === "A" ||
        cattleProducer.status === "Active"
    );
    yield put(
      CattleProducerActions.getDropdownCattleProducersSuccess(onlyActives)
    );
  } catch (error) {
    yield put(
      CattleProducerActions.getDropdownCattleProducersError(error)
    );
  }
}

